
import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import axios from 'axios';

// Base URL for your API
const BaseUrl = process.env.REACT_APP_API_URL;
// const BaseUrl = "http://192.168.88.203:5000";

// --- Asynchronous Thunks ---


// --- Add Slab Thunk ---
export const addSlab = createAsyncThunk(
    'slabslice/addSlab',
    async ({ values }, { rejectWithValue }) => {
        try {
            const response = await axios.post(`${BaseUrl}/slab_add`, values);
            return response.data;
        } catch (error) {
            return rejectWithValue(error.response?.data?.message || "Failed to add slab");
        }
    }
);

// --- View Slab List Thunk ---
export const fetchSlabList = createAsyncThunk(
    'slabslice/fetchSlabList',
    async (_, { rejectWithValue }) => {
        try {
            const response = await axios.get(`${BaseUrl}/slab_view`);
            return response.data.data;
        } catch (error) {
            return rejectWithValue(error.response?.data?.message || "Failed to fetch slab list");
        }
    }
);

// --- Update Slab Thunk ---
export const UpdateSlab = createAsyncThunk(
    'slabslice/updateSlab',
    async ({ id, values }, { rejectWithValue }) => {
        try {
            const response = await axios.put(`${BaseUrl}/slab_update/${id}`, values);
            return { id, updatedData: response.data?.data || values };
        } catch (error) {
            return rejectWithValue(error.response?.data?.message || "Failed to update item");
        }
    }
);

// --- Delete Slab Thunk ---
export const DeleteSlab = createAsyncThunk(
    'slabslice/deleteSlab',
    async ({ id }, { rejectWithValue }) => {
        try {
            const response = await axios.get(`${BaseUrl}/slab_delete/${id}`);
            return { id, message: response.data?.message || "Deleted successfully" };
        } catch (error) {
            return rejectWithValue(error.response?.data?.message || "Failed to delete version");
        }
    }
);

// --- Add Slab Detail Thunk ---
export const AddSlabDetail = createAsyncThunk(
    'slabslice/addSlabDetail',
    async ({ whaSlabID, dataToPost }, { rejectWithValue }) => {
        try {
            const response = await axios.post(`${BaseUrl}/slabdt_add/${whaSlabID}`, dataToPost,);
            return response.data;
        } catch (error) {
            return rejectWithValue(error.response?.data?.message || "Failed to add slab detail");
        }
    }
);

// --- View Slab Detail List Thunk ---
export const fetchSlabDetailList = createAsyncThunk(
    'slabslice/fetchSlabDetailList',
    async (_, { rejectWithValue }) => {
        try {
            const response = await axios.get(`${BaseUrl}/slabdt_view`);
            return response.data.data;
        } catch (error) {
            return rejectWithValue(
                error.response?.data?.message || "Failed to fetch slab detail list"
            );
        }
    }
);

// --- Update Slab Detail Thunk ---
export const UpdateSlabDetail = createAsyncThunk(
    'slabslice/updateSlabDetail',
    async ({ id, dataToPost }, { rejectWithValue }) => {
        try {
            const response = await axios.put(`${BaseUrl}/slabdt_update/${id}`, dataToPost);
            return { id, dataToPost: response.data?.data || dataToPost };
        } catch (error) {
            return rejectWithValue(error.response?.data?.message || "Failed to update slab detail");
        }
    }
);

// --- Delete Slab Detail Thunk ---
export const DeleteSlabDetail = createAsyncThunk(
    'slabslice/deleteSlabDetail',
    async ({ id }, { rejectWithValue }) => {
        try {
            const response = await axios.get(`${BaseUrl}/slabdt_delete/${id}`);
            return { id, message: response.data?.message || "Slab detail deleted" };
        } catch (error) {
            return rejectWithValue(
                error.response?.data?.message || "Failed to delete slab detail"
            );
        }
    }
);

// --- Redux Slice ---
const SlabSlice = createSlice({
    name: 'slabslice',
    initialState: {

        // Slab
        AddSlabData: null,
        addSlabLoading: false,
        addSlabError: null,

        // View Slab
        SlabDataList: [],
        slabListLoading: false,
        slabListError: null,

        updateSlabLoading: false,
        updateSlabError: null,

        deleteSlabLoading: false,
        deleteSlabError: null,

        // Add inside initialState
        AddSlabDetailData: null,
        addSlabDetailLoading: false,
        addSlabDetailError: null,

        // Slab Detail View
        SlabDetailList: [],
        slabDetailLoading: false,
        slabDetailError: null,
    },
    reducers: {},
    extraReducers: (builder) => {
        builder
            // ---- Add Slab ----
            .addCase(addSlab.pending, (state) => {
                state.addSlabLoading = true;
                state.addSlabError = null;
            })
            .addCase(addSlab.fulfilled, (state, action) => {
                state.addSlabLoading = false;
                state.AddSlabData = action.payload;
            })
            .addCase(addSlab.rejected, (state, action) => {
                state.addSlabLoading = false;
                state.addSlabError = action.payload;
            })

            // ---- Fetch Slab List ----
            .addCase(fetchSlabList.pending, (state) => {
                state.slabListLoading = true;
                state.slabListError = null;
            })
            .addCase(fetchSlabList.fulfilled, (state, action) => {
                state.slabListLoading = false;
                state.SlabDataList = action.payload;
            })
            .addCase(fetchSlabList.rejected, (state, action) => {
                state.slabListLoading = false;
                state.slabListError = action.payload;
            })

            // ---- Update Slab List ----
            .addCase(UpdateSlab.pending, (state) => {
                state.updateSlabLoading = true;
                state.updateSlabError = null;
            })
            .addCase(UpdateSlab.fulfilled, (state, action) => {
                state.updateSlabLoading = false;
                const index = state.SlabDataList.findIndex(item => item._id === action.payload.id);
                if (index !== -1) {
                    state.SlabDataList[index] = {
                        ...state.SlabDataList[index],
                        ...action.payload.updatedData,
                    };
                }
            })
            .addCase(UpdateSlab.rejected, (state, action) => {
                state.updateSlabLoading = false;
                state.updateSlabError = action.payload;
            })

            // ---- Delete Slab List ----
            .addCase(DeleteSlab.pending, (state) => {
                state.deleteSlabLoading = true;
                state.deleteSlabError = null;
            })
            .addCase(DeleteSlab.rejected, (state, action) => {
                state.deleteSlabLoading = false;
                state.deleteSlabError = action.payload;
            })
            .addCase(DeleteSlab.fulfilled, (state, action) => {
                state.deleteSlabLoading = false;
                state.SlabDataList = state.SlabDataList.filter(
                    (item) => item._id !== action.payload.itemId
                );
            })

            // Add inside builder
            .addCase(AddSlabDetail.pending, (state) => {
                state.addSlabDetailLoading = true;
                state.addSlabDetailError = null;
            })
            .addCase(AddSlabDetail.fulfilled, (state, action) => {
                state.addSlabDetailLoading = false;
                state.AddSlabDetailData = action.payload;
            })
            .addCase(AddSlabDetail.rejected, (state, action) => {
                state.addSlabDetailLoading = false;
                state.addSlabDetailError = action.payload;
            })

            // ---- Fetch Slab Detail List ----
            .addCase(fetchSlabDetailList.pending, (state) => {
                state.slabDetailLoading = true;
                state.slabDetailError = null;
            })
            .addCase(fetchSlabDetailList.fulfilled, (state, action) => {
                state.slabDetailLoading = false;
                state.SlabDetailList = action.payload;
            })
            .addCase(fetchSlabDetailList.rejected, (state, action) => {
                state.slabDetailLoading = false;
                state.slabDetailError = action.payload;
            })

            // ---- Update Slab Detail ----
            .addCase(UpdateSlabDetail.pending, (state) => {
                state.updateSlabLoading = true;
                state.updateSlabError = null;
            })
            .addCase(UpdateSlabDetail.fulfilled, (state, action) => {
                state.updateSlabLoading = false;
                const index = state.SlabDetailList.findIndex(item => item._id === action.payload.id);
                if (index !== -1) {
                    state.SlabDetailList[index] = {
                        ...state.SlabDetailList[index],
                        ...action.payload.updatedData,
                    };
                }
            })
            .addCase(UpdateSlabDetail.rejected, (state, action) => {
                state.updateSlabLoading = false;
                state.updateSlabError = action.payload;
            })
    }
});

// Export the reducer
export default SlabSlice.reducer;